import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomAttachFilesComponent } from 'src/app/components/custom-attach-files/custom-attach-files.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { CostCenterEnums } from 'src/app/enum/cost-center-enums';
import { ElectronicDocumentEnums } from 'src/app/enum/electronic-document-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { InvoiceEnums } from 'src/app/enum/invoice-enums';
import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { TypeConceptEnums } from 'src/app/enum/type-concept-enums';
import { TypeDianEnums } from 'src/app/enum/type-dian-enum';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ChargeAccountsPrintsModel } from 'src/app/models/invoicing/charge-accounts-prints.model';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { SellerService } from 'src/app/services/archive/seller.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ChargeAccountDetailService } from 'src/app/services/others/charge-account-detail.service';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ListChargeAccountConceptComponent } from '../../charge-account-concept/list-charge-account-concept/list-charge-account-concept.component';
import { AnnulChargeAccountComponent } from '../annul-charge-account/annul-charge-account.component';
import { ChargeAccountPrintingRangeComponent } from '../charge-account-printing-range/charge-account-printing-range.component';
import { CopyChargeAccountComponent } from '../copy-charge-account/copy-charge-account.component';

@Component({
  selector: 'app-register-charge-account',
  templateUrl: './register-charge-account.component.html',
  styleUrls: ['./register-charge-account.component.scss'],
  standalone: false
})
export class RegisterChargeAccountComponent implements OnInit {
  @ViewChild('attachFileChargeAccount') attachFileChargeAccountComponent?: CustomModalComponent | null = null;
  @ViewChild('copyChargeAccount') copyChargeAccountComponent?: CustomModalComponent | null = null;
  @ViewChild('generalDiscount') generalDiscountComponent?: CustomModalComponent | null = null;
  @ViewChild('printRange') printRangeComponent?: CustomModalComponent | null = null;
  @ViewChild('annulChargeAccount') annulChargeAccountComponent?: CustomModalComponent | null = null;

  activePanel: string = "";
  ascendant: boolean = true;
  branchId: number = 0;
  breakpointsForCopy: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  bussinessDocumentsTypeId: number = BussinessDocumentsClassEnums.cuentaCobro;
  bussinessDocumentsTypeIsRental: string = '';
  chargeAccountContract: InvoiceModel = new InvoiceModel();
  chargeAccountId: number;
  chargeAccountPrintModel: ChargeAccountsPrintsModel[] = [];
  chargeAccountStateString: string = '';
  chargeAccountTraffic: string = '';
  classInputClient: string = '';
  classInputCostCenter: string = '';
  clientId: number = 0;
  codeCurrency: string = '';
  columnSort: string | null = null;
  companyId: number = 0;
  componentAttachFiles = CustomAttachFilesComponent;
  componentCopyChargeAccount = CopyChargeAccountComponent;
  componentPrintRange = ChargeAccountPrintingRangeComponent;
  componentGeneralDiscount = ListChargeAccountConceptComponent;
  componentAnnulChargeAccount = AnnulChargeAccountComponent;
  disabledForm: boolean = false;
  enableSetChargeAccountWalletType: boolean = false;
  enterpriseId: number = 0;
  expirationDays: number | null = 0;
  expirationDaysCompany: number | null = 0;
  exporterChargeAccountDetailsPreview: boolean = false;
  filteredCostCenters: any[] = [];
  filteredBussinessDocumentsTypes: any[] = [];
  finishLoadingPrint: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formChargeAccountFirst: FormGroup = new FormGroup({});
  formChargeAccountFooter: FormGroup = new FormGroup({});
  iconPreviewChargeAccount: string = "pi pi-eye";
  iconStateChargeAccount: string = "lock_open";
  invoicingCutoffCode: number | string = '';
  inputsForCopyChargeAccount$ = new BehaviorSubject<any>({
    chargeAccountModel: 0,
    listBussinessDocumentsTypes: []
  });
  inputsForAttachFiles$ = new BehaviorSubject<any>({
    listFiles: [],
    labelConsecutive: 0,
    disabled: false
  });
  inputsForPrintRange$ = new BehaviorSubject<any>({
    chargeAccountModel: 0,
  });
  inputsForAnnulChargeAccount$ = new BehaviorSubject<any>({
    chargeAccountModel: 0,
  });
  inputsForGeneralDiscount$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    companyId: 0,
    chargeAccountModel: 0,
  });
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listBranches: any[] = [];
  listBussinessDocumentsTypes: any[] = [];
  listChargeAccountOperation: CustomListDropdown[] = [];
  listChargeAccountWalletType: CustomListDropdown[] = [];
  listClients: CustomListDropdown[] = [];;
  listCostCenters: any[] = [];
  listEnterprises: CustomListDropdown[] = [];
  listFiles: any[] = [];
  listPaymentMethods: any[] = [];
  listSellers: any[] = [];
  listTypeDIANs: any[] = [];
  listZones: any[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  messageStateChargeAccount: string = "";
  movementCode: number | string = '';
  nameWindow: string = 'Captura Cuentas de Cobro';
  outputForAttachFiles$ = new Subject<any>();
  outputGeneralDiscount$ = new Subject<any>();
  page: number = 1;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  previewChargeAccount: boolean = false;
  printChargeAccountFormat: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  showAccordion: boolean = false;
  showAllCostCenter: number = CostCenterEnums.Todos;
  stateClientId: number | null = 0;
  subscription: Subscription;
  invoiceOriginConsecutive: number | null = null;
  isFormView: boolean = false;
  stateCostCenterId: number = 0;
  titlePreviewChargeAccount: string = "Vista Previa";
  titleStateChargeAccount: string = "";
  typeBussines: number = TypeConceptEnums.tipoNegocio;
  updateListDetail: boolean = false;
  updateTotals: boolean = false;
  url: string = "charge-account";
  userAuthenticated: UserModel = new UserModel();
  visibleAnnul: boolean = false;
  visibleLoading: boolean = true;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private chargeAccountDetailService: ChargeAccountDetailService,
    private chargeAccountService: ChargeAccountService,
    private confirmDialogService: ConfirmDialogService,
    private costCenterService: CostCenterService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formatService: FormatService,
    private formBuilder: FormBuilder,
    private invoiceService: InvoiceService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private headerService: HeaderService,
    private sellerService: SellerService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.chargeAccountContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    await this.getPermissionPrint();
    this.activatedRoute.params.subscribe(params => {
      this.chargeAccountId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.outputForAttachFiles$.subscribe(async ({ type, payload }) => {
      switch (type) {
        case 'uploadFile':
          this.uploadFile(payload);
          break;
        case 'downloadFile':
          this.downloadFile(payload);
          break;
        case 'deleteFile':
          this.deleteFile(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  addDaysToDate(days: number | null) {
    if (days != null && days != 0) {
      const date = new Date(this.formChargeAccountFirst.get("dateInvoice")?.value);
      const dateExpiration: Date = moment(date).add(days, 'days').toDate();
      this.formChargeAccountFirst.controls["dateExpiration"].patchValue(dateExpiration);
    }
  }

  applyExpirationForNewInvoice() {
    if (this.chargeAccountId === 0) {
      this.addDaysToDate(this.expirationDaysCompany);
      this.expirationDays = this.expirationDaysCompany;
    }
  }

  async blockChargeAccount(check: boolean) {
    if (this.chargeAccountContract.invoiceId != 0) {
      try {
        this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.blockChargeAccount(this.chargeAccountContract.invoiceId));
        this.validateForm(this.chargeAccountContract);
      } catch (error) {
        this.formChargeAccountFirst.controls["swBlock"].patchValue(!check);
        console.error('Error al bloquear la cuenta de cobro.', error);
      }
    } else {
      this.formChargeAccountFirst.controls["swBlock"].patchValue(!check);
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado de la cuenta de cobro.'
      );
    }
  }

  toggleAccordion() {
    this.showAccordion = !this.showAccordion;
    this.isFormView = false;
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getFirstEnterpriseByBranch();
      await this.getAllLists('enterprises', 'costCenters', 'sellers', 'zones', 'bussinessDocumentsTypes');
      this.createNewChargeAccount();
    }
  }

  changeBussinessDocumentsType() {
    this.branchId = this.formChargeAccountFirst.get("branchId")?.value;
    this.enterpriseId = this.formChargeAccountFirst.get("enterpriseId")?.value;
    this.bussinessDocumentsTypeId = this.formChargeAccountFirst.get("bussinessDocumentsTypeId")?.value;
    this.createNewChargeAccount();
  }

  async changeConsecutive() {
    let consecutive = this.formChargeAccountFirst.get("consecutive")?.value;
    if (this.chargeAccountContract.consecutive == consecutive) return;
    const branchId = this.formChargeAccountFirst.get("branchId")?.value;
    const enterpriseId = this.formChargeAccountFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formChargeAccountFirst.get("bussinessDocumentsTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Empresa.'
      );
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un Tipo de Documento Comercial.'
      );
      return;
    } else if (consecutive == 0) {
      consecutive = null;
    }

    if (consecutive == null) {
      this.chargeAccountId = 0;
      const modelChargeAccount = new InvoiceModel();
      modelChargeAccount.branchId = branchId;
      modelChargeAccount.enterpriseId = enterpriseId;
      modelChargeAccount.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
      this.chargeAccountContract = modelChargeAccount;
    } else {
      try {
        this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.getChargeAccountByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive));
        this.chargeAccountId = this.chargeAccountContract.invoiceId;
        this.validateForm(this.chargeAccountContract);
        this.location.replaceState(`/charge-account/register/${this.chargeAccountId}`);
      } catch (error) {
        const modelInvoice = new InvoiceModel();
        modelInvoice.invoiceId = -1;
        modelInvoice.branchId = branchId;
        modelInvoice.enterpriseId = enterpriseId;
        modelInvoice.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
        modelInvoice.consecutive = consecutive;
        console.error('Error al buscar la cuenta de cobro por llaves.', error);
      }
    }
  }

  async changeEnterprise(enterpriseId: number) {
    this.branchId = this.formChargeAccountFirst.get("branchId")?.value;
    this.enterpriseId = enterpriseId;
    await Promise.all([
      this.getFirstBussinessDocumentsType(),
      this.getAllLists('bussinessDocumentsTypes'),
    ]);
    this.createNewChargeAccount();
  }

  changeChargeAccount(chargeAccount: InvoiceModel) {
    this.chargeAccountContract = chargeAccount;
    this.validateForm(chargeAccount);
  }

  changeOperation(invoiceOperationId: number) {
    if (invoiceOperationId == InvoiceEnums.contado) {
      this.formChargeAccountFirst.controls["conceptPaymentMethodId"].patchValue(this.listPaymentMethods.find(x => x.code == InvoiceEnums.efectivo)?.value);
    }
    if (invoiceOperationId == InvoiceEnums.credito) {
      this.formChargeAccountFirst.controls["conceptPaymentMethodId"].patchValue(this.listPaymentMethods.find(x => x.code == InvoiceEnums.acuerdoMutuo)?.value);
    }
  }

  async changeStateChargeAccount() {
    if (this.chargeAccountContract.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La cuenta de cobro no está guardada.'
      );
      return;
    }
    if (this.chargeAccountContract.invoiceStateId == InvoiceEnums.anulada) {
      this.openAnnulChargeAccount();
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.setStateChargeAccount(this.chargeAccountContract.invoiceId));
        this.validateForm(this.chargeAccountContract);
        this.toastHandlerService.showToast(
          'success',
          'El estado de la cuenta de cobro se modificó exitosamente.'
        );
      } catch (error) {
        console.error('Error al cambiar el estado de la cuenta de cobro.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de Cuentas de cobro. Comuníquese con el administrador del sistema.'
      );
    }
  }

  clearForm() {
    this.chargeAccountContract = new InvoiceModel();
    this.previewChargeAccount = false;
    this.iconPreviewChargeAccount = "pi pi-eye";
    this.titlePreviewChargeAccount = "Vista Previa";
  }

  close() {
    if (this.previewChargeAccount) {
      this.previewChargeAccount = false;
      this.iconPreviewChargeAccount = "pi pi-eye";
      this.titlePreviewChargeAccount = "Vista Previa";
    } else {
      this.router.navigate(['/charge-account']);
    }
  }

  async createNewChargeAccount() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear cuentas de cobros.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.clientId = 0;
    this.chargeAccountId = 0;
    this.quantityDetails = 0;
    this.movementCode = "";
    this.invoicingCutoffCode = "";
    this.chargeAccountPrintModel = [];
    this.stateClientId = ClientStateEnums.activo;
    this.stateCostCenterId = ClientStateEnums.activo;
    this.filteredCostCenters = this.listCostCenters;
    this.chargeAccountContract = new InvoiceModel();
    this.chargeAccountContract.branchId = this.branchId;
    this.chargeAccountContract.enterpriseId = this.enterpriseId;
    this.chargeAccountContract.bussinessDocumentsTypeId = this.bussinessDocumentsTypeId;
    await this.validateForm(this.chargeAccountContract);
    this.applyExpirationForNewInvoice();
    this.location.replaceState(`/charge-account/register`);
  }

  async deleteChargeAccount() {
    if (this.chargeAccountContract.invoiceId != 0) {
      if (!this.permissionUpdatable) {
        this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para eliminar Cuentas de cobro. Comuníquese con el administrador del sistema.');
        return;
      }

      if (this.quantityDetails > 0) {
        this.toastHandlerService.showToast('error', 'No es posible eliminar la cuenta de cobro mientras tenga detalle.');
        return;
      }

      const accepted = await this.confirmDialogService.confirm("La cantidad o el valor de artículos a facturar es cero. ¿Realmente desea ingresar el registro?.");
      if (accepted) {
        try {
          await firstValueFrom(this.chargeAccountService.deleteChargeAccount(this.chargeAccountContract.invoiceId));
          this.toastHandlerService.showToast(
            'success',
            'La cuenta de cobro fue eliminada exitosamente.'
          );
          this.createNewChargeAccount();
        } catch (error) {
          console.error('Error al eliminar la cuenta de cobro.', error);
        }
      }

    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado de la cuenta de cobro.'
      );
    }
  }

  async deleteFile(file: any) {
    if (this.chargeAccountContract.invoiceId != 0) {
      const accepted = await this.confirmDialogService.confirm("¿Realmente desea eliminar el adjunto seleccionado?");
      if (accepted) {
        try {
          await firstValueFrom(this.chargeAccountService.deleteFilesToChargeAccount(this.chargeAccountContract.invoiceId, file));
          this.toastHandlerService.showToast('success', 'El adjunto fue eliminado exitosamente', '');
          this.getFilesToChargeAccount();
        } catch (error) {
          console.error('Error catch:', error);
        }
      }
    }
  }

  downloadFile(fileName: any) {
    if (this.chargeAccountContract.invoiceId != 0) {
      this.chargeAccountService.downloadFileToChargeAccount(this.chargeAccountContract.invoiceId, fileName).subscribe(data => {
        switch (data.type) {
          case HttpEventType.Response: {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = fileName;
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
        }
      });
    }
  }

  async editChargeAccount() {
    this.chargeAccountPrintModel = [];
    await this.getChargeAccountById();
  }

  exporterDetailsPreview() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.ExportarVistaPrevia)) {
      this.exporterChargeAccountDetailsPreview = !this.exporterChargeAccountDetailsPreview;
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para exportar la Vista Previa de la cuenta de cobro, comuniquese con el administrador del sistema.'
      );
    }
  }

  emitTraffic(traffic: string) {
    this.chargeAccountTraffic = traffic;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'enterprises' | 'clients' | 'costCenters' | 'typeDIANs' | 'invoiceOperations' |
    'bussinessDocumentsTypes' | 'sellers' | 'paymentMethods' | 'invoiceWalletTypes' | 'zones'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        enterprises: async () => {
          this.listEnterprises = await firstValueFrom(
            this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)
          );
        },
        clients: async () => {
          this.listClients = await firstValueFrom(
            this.invoiceService.getAllClientsForSelectAsync()
          );
        },
        costCenters: async () => {
          this.listCostCenters = await firstValueFrom(
            this.chargeAccountService.getCostCentersForSelectAsync(this.branchId)
          );
          this.filteredCostCenters = this.listCostCenters;
        },
        typeDIANs: async () => {
          this.listTypeDIANs = await firstValueFrom(
            this.invoiceService.getAllTypeDIANForSelectAsync()
          );
        },
        invoiceOperations: async () => {
          this.listChargeAccountOperation = await firstValueFrom(
            this.invoiceService.getAllInvoiceOperationsForSelectAsync()
          );
        },
        bussinessDocumentsTypes: async () => {
          this.listBussinessDocumentsTypes = await firstValueFrom(
            this.chargeAccountService.getAllBussinessDocumentsTypesForSelectAsync(this.branchId, this.enterpriseId)
          );
        },
        sellers: async () => {
          this.listSellers = await firstValueFrom(
            this.sellerService.getAllSellersForSelectByBranchIdAsync(this.branchId)
          );
        },
        paymentMethods: async () => {
          this.listPaymentMethods = await firstValueFrom(
            this.invoiceService.getAllPaymentMethodsForSelectAsync()
          );
        },
        invoiceWalletTypes: async () => {
          this.listChargeAccountWalletType = await firstValueFrom(
            this.invoiceService.getAllInvoiceWalletTypeForSelectAsync()
          );
        },
        zones: async () => {
          this.listZones = await firstValueFrom(
            this.invoiceService.getAllZonesByBranchIdForSelects(this.branchId)
          );
        },

      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.zones(),
          lists.sellers(),
          lists.clients(),
          lists.branches(),
          lists.typeDIANs(),
          lists.enterprises(),
          lists.costCenters(),
          lists.paymentMethods(),
          lists.invoiceOperations(),
          lists.invoiceWalletTypes(),
          lists.bussinessDocumentsTypes()
        ]);
      }
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }


  async getDetailsChargeAccountWithPagination() {
    try {
      const response = await firstValueFrom(this.chargeAccountDetailService.getChargeAccountsDetailsByChargeAccountIdWithPagination(this.page,
        this.limit, this.columnSort, this.ascendant, this.chargeAccountId));
      this.quantityDetails = response.totalItems;
    } catch (error) {
      console.error('Error al buscar los detalles de las cuentas de cobro.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      this.formatModel = await firstValueFrom(
        this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.chargeAccount)
      );
    } catch (error) {
      console.error('Error al obtener el formato:', error);
    }
  }

  async getBranch(branchId: number, reload: boolean) {
    try {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      this.branchId = branch.branchId;
      if (reload) {
        await this.changeBranch(branch.branchId, false);
      }
    } catch (error) {
      console.error('Error al obtener la sucursal.', error);
    }
  }

  getBussinessDocumentsType(bussinessDocumentsTypeId: number | null, reload: boolean) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      const bussinessDocumentsType = this.listBussinessDocumentsTypes.find(x => x.value == bussinessDocumentsTypeId);
      if (bussinessDocumentsType) {
        this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
        const isRental = bussinessDocumentsType.isRental === true;
        isRental ? this.bussinessDocumentsTypeIsRental = 'Alquiler' : this.bussinessDocumentsTypeIsRental = 'Venta';
        if (bussinessDocumentsType.bussinessDocumentsDianTypeId == ElectronicDocumentEnums.tipoDianFacturaExportacion) {
          this.showAllCostCenter = CostCenterEnums.CcoMonedaDiferente;
        } else {
          this.showAllCostCenter = CostCenterEnums.Todos;
        }
      } else {
        this.showAllCostCenter = CostCenterEnums.Todos;
        return;
      }
    } else {
      this.showAllCostCenter = CostCenterEnums.Todos;
    }

    if (reload) {
      this.changeBussinessDocumentsType();
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formChargeAccountFirst.get("branchId")?.value;
    const enterpriseId = this.formChargeAccountFirst.get("enterpriseId")?.value;
    const bussinessDocumentsTypeId = this.formChargeAccountFirst.get("bussinessDocumentsTypeId")?.value;
    const consecutive = this.formChargeAccountFirst.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Empresa.'
      );
      return;
    } else if (bussinessDocumentsTypeId == null || bussinessDocumentsTypeId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un Tipo de Documento Comercial.'
      );
      return;
    }
    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.getFirstChargeAccountByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId));
          this.chargeAccountId = this.chargeAccountContract.invoiceId;
          this.validateForm(this.chargeAccountContract);
          this.location.replaceState(`/charge-account/register/${this.chargeAccountId}`);
        } catch (error) {
          console.error('Error al buscar la primera cuenta de cobro.', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.getPreviusChargeAccountByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive));
          this.chargeAccountId = this.chargeAccountContract.invoiceId;
          this.validateForm(this.chargeAccountContract);
          this.location.replaceState(`/charge-account/register/${this.chargeAccountId}`);
        } catch (error) {
          console.error('Error al buscar la cuenta de cobro anterior.', error);
        }
        break;
      }
      case 'next': {
        try {
          this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.getNextChargeAccountByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId, consecutive));
          this.chargeAccountId = this.chargeAccountContract.invoiceId;
          this.validateForm(this.chargeAccountContract);
          this.location.replaceState(`/charge-account/register/${this.chargeAccountId}`);
        } catch (error) {
          console.error('Error al buscar la cuenta de cobro siguiente.', error);
        }
        break;
      }
      case 'last': {
        try {
          this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.getLastChargeAccountByKeysAsync(branchId, enterpriseId, bussinessDocumentsTypeId));
          this.chargeAccountId = this.chargeAccountContract.invoiceId;
          this.validateForm(this.chargeAccountContract);
          this.location.replaceState(`/charge-account/register/${this.chargeAccountId}`);
        } catch (error) {
          console.error('Error al buscar la ultima cuenta de cobro.', error);
        }
        break;
      }
    }
  }

  async getChargeAccountById() {
    try {
      const response = await firstValueFrom(this.chargeAccountService.getChargeAccountById(this.chargeAccountId));
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
      this.enterpriseId = response.enterpriseId;
      this.chargeAccountContract = response;
      await this.changeBranch(response.branchId, true);
      this.validateForm(this.chargeAccountContract);
    } catch (error) {
      console.error('Error al buscar la cuenta de cobro por id.', error);
    }
  }

  getClass(selection: string): string {
    const state = selection === 'client'
      ? this.stateClientId
      : this.stateCostCenterId;

    return state === ClientStateEnums.activo ? '' : 'state-inactive';
  }

  async getClient(clientId: number | null, validate: boolean) {
    this.filterCostCenterByClientId(clientId);
    const clientOld = this.chargeAccountContract.clientId;
    if (clientId != null && clientId != 0) {
      if (clientOld != clientId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede cambiar el cliente si la cuenta de cobro tiene detalle.'
        );
      } else {
        const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
        if (client.clientStateId == ClientStateEnums.inactivo && validate) {
          this.toastHandlerService.showToast(
            'warning',
            'El cliente seleccionado se encuentra inactivo.'
          );
          this.stateClientId = client.clientStateId as number | null;
          this.formChargeAccountFirst.controls["clientId"].patchValue(null);
          this.formChargeAccountFirst.controls["costCenterId"].patchValue(null);
          this.filteredCostCenters = this.listCostCenters;
          return;
        }
        if (client) {
          this.clientId = clientId;
          this.codeCurrency = client.codeCurrency;
          this.stateClientId = client.clientStateId as number | null;
          this.expirationDays = client.expirationDays;

          const exist = this.listClients.some(c => c.value === this.clientId);
          if (!exist) {
            this.listClients.push({ label: client.label, value: this.clientId });
          }
          this.formChargeAccountFirst.controls["clientId"].patchValue(this.clientId);

          //Asignar fecha de vencimiento
          if (this.chargeAccountContract.invoiceId == 0 || clientOld != clientId) {
            if (client.swExpirationDays) {
              this.addDaysToDate(this.expirationDays);
            } else {
              this.addDaysToDate(this.expirationDaysCompany);
            }
          }
          //Si cambio el cliente, limpio el cco
          if (clientOld != 0 && clientOld != clientId) this.getCostCenter(null, false);
        } else {
          if (this.quantityDetails != 0) {
            this.toastHandlerService.showToast(
              'error',
              'Error al buscar el elemento, por favor refresque la página.'
            );
          } else {
            this.formChargeAccountFirst.controls["clientId"].patchValue(0);
            this.codeCurrency = "";
            this.clientId = 0;
            this.stateClientId = ClientStateEnums.activo;
            this.getCostCenter(null, false);
            //Restablecer fecha de vencimiento
            this.addDaysToDate(this.expirationDaysCompany);
            this.formChargeAccountFirst.controls["costCenterId"].patchValue(0);
          }
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el cliente si la cuenta de cobro tiene detalle.'
        );
      } else {
        this.clientId = 0;
        this.codeCurrency = "";
        this.formChargeAccountFirst.controls["clientId"].patchValue(null);
        this.stateClientId = 0;
        this.getCostCenter(null, false);
        //Restablecer fecha de vencimiento
        this.addDaysToDate(this.expirationDaysCompany);
        this.formChargeAccountFirst.controls["costCenterId"].patchValue(null);
      }
    }
  }

  filterCostCenterByClientId(clientId: number | null) {
    const rowsFiltered = this.listCostCenters.filter(cc => cc.clientId == clientId);
    if (clientId != null) {
      this.filteredCostCenters = rowsFiltered;
      const costCenterId = this.formChargeAccountFirst.get("costCenterId")?.value;
      const costCenterClient = this.listCostCenters.find(x => x.clientId == clientId);
      if ((costCenterId && costCenterClient) && costCenterClient.value != costCenterId) {
        this.formChargeAccountFirst.controls["costCenterId"].patchValue(null);
      }
    } else {
      this.filteredCostCenters = this.listCostCenters;
    }
  }

  async getCostCenter(costCenterId: number | null, validate: boolean) {
    if (costCenterId != null && costCenterId != 0) {
      const costCenterOld = this.chargeAccountContract.costCenterId;
      const costCenterModel = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
      if (costCenterOld != costCenterModel.costCenterId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede cambiar el c.costos si la cuenta de cobro tiene detalle.'
        );
      } else {
        const exist = this.listCostCenters.some(c => c.value == costCenterId);
        if (!exist && costCenterModel) {
          this.listCostCenters.push({
            clientId: costCenterModel.clientId,
            label: `${costCenterModel.code} - ${costCenterModel.name}`,
            value: costCenterId
          });
        }
        this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;
        this.formChargeAccountFirst.controls["clientId"].patchValue(costCenterModel.clientId);
        await this.getClient(costCenterModel.clientId, false);
        this.formChargeAccountFirst.controls["costCenterId"].patchValue(costCenterId);
        if (validate) {
          if (costCenterModel.constructionSite.constructionSiteStateId == ConstructionSiteStateEnums.inactiva) {
            this.toastHandlerService.showToast(
              'warning',
              'El centro de costos seleccionado se encuentra inactivo.'
            );
            this.formChargeAccountFirst.controls["costCenterId"].patchValue(null);
            this.formChargeAccountFirst.controls["clientId"].patchValue(null);
            this.filteredCostCenters = this.listCostCenters.filter(x => x.value != costCenterId);
            return;
          }
        }
      }
    } else {
      if (this.chargeAccountContract.costCenterId != null && this.chargeAccountContract.costCenterId != 0 && this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el c.costos si la cuenta de cobro tiene detalle.'
        );
      } else {
        this.formChargeAccountFirst.controls["costCenterId"].patchValue(0);
      }
      this.stateCostCenterId = ClientStateEnums.activo;
    }
  }

  async getEnterprise(enterpriseId: number, reload: boolean) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      this.enterpriseId = response.enterpriseId;
      if (reload) {
        await this.changeEnterprise(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la empresa.', error);
    }
  }

  async getFilesToChargeAccount() {
    try {
      this.listFiles = await firstValueFrom(this.chargeAccountService.getFilesToChargeAccount(this.chargeAccountId));
      this.updateInputsForAttachFiles();
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    this.mainBranchByUser = await firstValueFrom(
      this.userAuthenticatedService.branchObservable.pipe(
        filter(branch => branch && branch.branchId !== 0)
      )
    );
    this.companyId = this.mainBranchByUser.companyId;
  }

  async getInitialData() {
    try {
      await this.getFirstBranchByUserAuthenticated();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado.', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getFirstEnterpriseByBranch();
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstBussinessDocumentsType() {
    try {
      const bussinessDocumentsClass = BussinessDocumentsClassEnums.cuentaCobro;
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsType(bussinessDocumentsClass, this.enterpriseId));
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
      this.getBussinessDocumentsType(response.bussinessDocumentsTypeId, false);
    } catch (error) {
      console.error('Error al buscar el tipo de documento de la cuenta de cobro.', error);
    }
  }

  async getFirstEnterpriseByBranch() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.enterpriseId = response.enterpriseId;
        await this.getFirstBussinessDocumentsType();
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getInvoicingCutoffCode(invoicingCutoffId: number | null) {
    if (invoicingCutoffId != null && invoicingCutoffId != 0) {
      this.invoicingCutoffCode = await firstValueFrom(this.invoiceService.getInvoicingCutoffCodeByIdAsync(invoicingCutoffId));
    } else {
      this.invoicingCutoffCode = "";
    }
  }

  async getMovementCode(movementId: number | null) {
    if (movementId != null && movementId != 0) {
      this.movementCode = await firstValueFrom(this.invoiceService.getMovementCodeById(movementId));
    } else {
      this.movementCode = "";
    }
  }

  async getParamsPrint(params: any) {
    this.chargeAccountTraffic = params.traffic;
    await this.getPrintChargeAccountsByRange(params.chargeAccountPrint)
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getUserAuthenticated();
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow(),
      this.getFormatByCompanyAndCode()
    ]);
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.chargeAccountService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión', error);
    }
  }

  async getUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
      this.expirationDaysCompany = response.company ? response.company.invoiceExpirationDays : null;
      this.companyId = response.companyId;
      this.userAuthenticated = response;
    } catch (error) {
      console.error('Error obtaining authenticated user:', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.ChargeAccount));
    } catch (error) {
      console.error('Error al buscar los permisos para el usuario.', error);
    }
  }

  async getPrintChargeAccountsByRange(chargeAccountPrintModel: ChargeAccountsPrintsModel[]) {
    if (chargeAccountPrintModel.length) {
      this.printChargeAccountFormat = true;
      this.previewChargeAccount = false;
      this.iconPreviewChargeAccount = "pi pi-eye";
      this.titlePreviewChargeAccount = "Vista Previa";
      this.toastHandlerService.clearAllToasts();
      setTimeout(() => this.printChargeAccount(chargeAccountPrintModel), 100);
    }
  }

  async handleInitialState() {
    if (this.chargeAccountId) {
      await this.editChargeAccount();
    } else {
      await this.getInitialData();
      this.createNewChargeAccount();
    }
  }

  async getPrintChargeAccounts() {
    try {
      this.visibleLoading = true;
      this.chargeAccountPrintModel = await firstValueFrom(this.chargeAccountService.printsChargeAccounts(this.chargeAccountContract.invoiceId, null, null, false));
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  async printChargeAccount(invoices: ChargeAccountsPrintsModel[]) {
    this.chargeAccountPrintModel = invoices;
    //Inicializo variable
    this.finishLoadingPrint = false;
    //Imprimo las facturas
    await this.waitForComponenteImpresionToLoad();
    this.chargeAccountContract = await firstValueFrom(this.chargeAccountService.getChargeAccountById(this.chargeAccountContract.invoiceId));
    this.validateForm(this.chargeAccountContract);
    //ocultar formato
    this.printChargeAccountFormat = false;
  }

  async getZone(zoneId: number | null) {
    if (zoneId != null && zoneId != 0) {
      const zone = this.listZones.find(x => x.value == zoneId);
      if (zone) {
        this.formChargeAccountFirst.controls["sellerId"].patchValue(zone.sellerId);
      } else {
        this.formChargeAccountFirst.controls["sellerId"].patchValue(null);
        this.formChargeAccountFirst.controls["zoneId"].patchValue(null);
      }
    } else {
      this.formChargeAccountFirst.controls["zoneId"].patchValue(null);
      this.formChargeAccountFirst.controls["sellerId"].patchValue(null);
    }
  }

  getUpdateChargeAccount(chargeAccount: InvoiceModel) {
    this.chargeAccountContract = chargeAccount;
    this.validateForm(this.chargeAccountContract);
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/charge-account']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  newDetail(event?: any) {
    // 1. Detener cualquier propagación remanente
    if (event) {
      event.stopPropagation();
      event.preventDefault();
      //sw para abrir y cerrar formulario y accordion
      this.isFormView = !this.isFormView
      if (!this.isFormView) setTimeout(() => { this.isFormView = true }, 100);
    }

    if (this.chargeAccountContract.invoiceId != 0) {
      this.activePanel = "0";
      this.showAccordion = true;
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la cuenta de cobro.', 'Atención');
    }
  }


  async openAttachFile() {
    if (this.chargeAccountContract.invoiceId != 0 && this.chargeAccountContract.invoiceId != null) {
      await this.getFilesToChargeAccount();
      this.attachFileChargeAccountComponent && this.attachFileChargeAccountComponent.show();
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear una cuenta de cobro.', 'Atención');
    }
  }

  async openAnnulChargeAccount() {
    if (this.chargeAccountContract.invoiceId == 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado de la cuenta de cobro.`, 'Atención.');
      return;
    } else if (this.chargeAccountContract.swBlock) {
      this.toastHandlerService.showToast('warning', `El Documento Actualmente se encuentra Bloqueado, Consulte con el Administrador del Sistema.`, 'Atención.');
      return;
    }

    const response = await firstValueFrom(this.chargeAccountService.getPermissionAnnulChargeAccount(this.chargeAccountContract.invoiceId));
    if (!response) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para anular cuentas de cobro, Consulte con el Administrador del Sistema.`, 'Atención.');
      return
    }

    this.inputsForAnnulChargeAccount$.next({
      chargeAccountModel: this.chargeAccountContract,
    });
    this.annulChargeAccountComponent?.show();
  }

  async openCopyChargeAccount() {
    if (this.chargeAccountContract.invoiceId == 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado de la cuenta de cobro.`, 'Atención.');
      return;
    } else if (this.chargeAccountContract.swBlock) {
      this.toastHandlerService.showToast('warning', `El Documento Actualmente se encuentra Bloqueado, Consulte con el Administrador del Sistema.`, 'Atención.');
      return;
    } else if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', `No es posible copiar datos a esta cuenta de cobro. Ya tiene líneas de detalle.`, 'Atención.');
      return;
    }

    this.inputsForCopyChargeAccount$.next({
      chargeAccountModel: this.chargeAccountContract,
      listBussinessDocumentsTypes: this.listBussinessDocumentsTypes,
    });
    this.copyChargeAccountComponent?.show();
  }

  openGeneralConcept() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para aplicar descuentos,
        comuniquese con el administrador del sistema.`);
      return;
    }
    this.inputsForGeneralDiscount$.next({
      chargeAccountModel: this.chargeAccountContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm
    });
    this.generalDiscountComponent?.show();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getDetailsChargeAccountWithPagination();
  }

  async openPreviewChargeAccount() {
    if (this.chargeAccountContract.invoiceId != 0) {
      this.previewChargeAccount = !this.previewChargeAccount;
      if (this.previewChargeAccount) {
        this.iconPreviewChargeAccount = "pi pi-address-book";
        this.titlePreviewChargeAccount = "Volver a cuenta de cobro";
        await this.getPrintChargeAccounts();
      } else {
        this.iconPreviewChargeAccount = "pi pi-eye";
        this.titlePreviewChargeAccount = "Vista Previa";
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado de la cuenta de cobro.'
      );
    }
  }

  async openPrintRange() {

    if (!this.permissionPrint) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para imprimir cuentas de cobro. Comuníquese con el administrador del sistema.');
      return;
    }

    if (this.chargeAccountContract.invoiceId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la cuenta de cobro.');
      return;
    }

    this.inputsForPrintRange$.next({
      chargeAccountModel: this.chargeAccountContract
    });
    this.printRangeComponent?.show();
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.chargeAccountId != 0 && this.chargeAccountId != null) {
      this.router.navigate(['/charge-account/register/', this.chargeAccountId]);
    } else {
      this.router.navigate(['/charge-account/register']);
    }
  }

  async reloadChargeAccount(params: any) {
    if (params.updateChargeAccount) {
      await this.getChargeAccountById();
    }
  }

  async send(): Promise<any> {
    this.validateFormControls();
    if (this.formChargeAccountFirst.valid) {
      const modelChargeAccount = this.setForm();
      if (modelChargeAccount.dateExpiration < modelChargeAccount.dateInvoice) {
        this.toastHandlerService.showToast(
          'warning',
          'La fecha de vencimiento debe ser MAYOR o IGUAL a la fecha de la cuenta de cobro.'
        );
        this.formChargeAccountFirst.controls["dateExpiration"].patchValue(null);
        return;
      }
      //Hago null, los campos que permiten ser nulos:
      if (modelChargeAccount.costCenterId == 0) modelChargeAccount.costCenterId = null;
      if (modelChargeAccount.invoiceOriginId == 0) modelChargeAccount.invoiceOriginId = null;
      if (modelChargeAccount.observation == "") modelChargeAccount.observation = null;
      modelChargeAccount.enterprise = null;

      if (this.chargeAccountId == 0) {
        // Agrego el Tipo DIAN por defecto
        modelChargeAccount.conceptTypeDIANId = await this.setTypeDIAN(modelChargeAccount.ivaTypeId);
        // Agrego el medio de pago por defecto
        modelChargeAccount.conceptPaymentMethodId = this.listPaymentMethods.find(x => x.code == InvoiceEnums.acuerdoMutuo)?.value;
        // Agrego la zona y el vendedor por defecto
        try {
          const response = await firstValueFrom(this.chargeAccountService.createChargeAccount(modelChargeAccount));
          this.toastHandlerService.showToast(
            'success',
            'La cuenta de cobro fue creada exitosamente.'
          );
          this.chargeAccountContract = response;
          this.chargeAccountId = this.chargeAccountContract.invoiceId;
          this.validateForm(this.chargeAccountContract);
          this.location.replaceState(`/charge-account/register/${this.chargeAccountId}`);
        } catch (error) {
          console.error('Error al crear la cuenta de cobro.', error);
        }
      } else {
        try {
          const response = await firstValueFrom(this.chargeAccountService.updateChargeAccount(this.chargeAccountContract));
          this.toastHandlerService.showToast(
            'success',
            'La cuenta de cobro fue modificada exitosamente.'
          );
          this.chargeAccountContract = response;
          this.validateForm(this.chargeAccountContract);
        } catch (error) {
          console.error('Error al actualizar la cuenta de cobro.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      enterpriseId: 'El campo empresa es obligatorio.',
      dateInvoice: 'El campo fecha es obligatorio.',
      dateExpiration: 'El campo fecha vencimiento es obligatorio.',
      clientId: 'El campo cliente es obligatorio.',
      zoneId: 'El campo nombre zona es obligatorio.',
      sellerId: 'El campo vendedor es obligatorio.',
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formChargeAccountFirst.controls[control].invalid) {
        this.toastHandlerService.showToast(
          'warning',
          controlMessages[control]
        );
      }
    });
  }

  setForm(): any {
    this.chargeAccountContract.branchId = this.formChargeAccountFirst.get("branchId")?.value;
    this.chargeAccountContract.enterpriseId = this.formChargeAccountFirst.get("enterpriseId")?.value;
    this.chargeAccountContract.bussinessDocumentsTypeId = this.formChargeAccountFirst.get("bussinessDocumentsTypeId")?.value;
    this.chargeAccountContract.consecutive = this.formChargeAccountFirst.get("consecutive")?.value;
    this.chargeAccountContract.conceptTypeDIANId = this.formChargeAccountFirst.get("conceptTypeDIANId")?.value;
    this.chargeAccountContract.dateInvoice = this.formChargeAccountFirst.get("dateInvoice")?.value;
    this.chargeAccountContract.dateExpiration = this.formChargeAccountFirst.get("dateExpiration")?.value;
    this.chargeAccountContract.clientId = this.formChargeAccountFirst.get("clientId")?.value;
    this.chargeAccountContract.costCenterId = this.formChargeAccountFirst.get("costCenterId")?.value;
    this.chargeAccountContract.observation = this.formChargeAccountFirst.get("observation")?.value;
    this.chargeAccountContract.invoiceStateId = this.formChargeAccountFirst.get("chargeAccountStateId")?.value;
    this.chargeAccountContract.swBlock = this.formChargeAccountFirst.get("swBlock")?.value;
    this.chargeAccountContract.swManual = this.formChargeAccountFirst.get("swManual")?.value;
    this.chargeAccountContract.swCopied = this.formChargeAccountFirst.get("swCopied")?.value;
    this.chargeAccountContract.zoneId = this.formChargeAccountFirst.get("zoneId")?.value;
    this.chargeAccountContract.sellerId = this.formChargeAccountFirst.get("sellerId")?.value;
    this.chargeAccountContract.invoiceOperationId = this.formChargeAccountFirst.get("chargeAccountOperationId")?.value as number;
    this.chargeAccountContract.invoiceWalletTypeId = this.formChargeAccountFirst.get("chargeAccountWalletTypeId")?.value as number;
    setTimeout(() => this.formChargeAccountFirst.controls["swManual"].disable(), 100);
    setTimeout(() => this.formChargeAccountFirst.controls["swCopied"].disable(), 100);
    return this.chargeAccountContract;
  }

  async setChargeAccountWalletType() {
    const accepted = await this.confirmDialogService.confirm("¿Realmente desea cambiar el tipo de cartera para esta cuenta de cobro?");
    if (accepted) {
      try {
        this.chargeAccountContract = await firstValueFrom(this.invoiceService.setInvoiceWalletType(this.chargeAccountContract.invoiceId));
        this.toastHandlerService.showToast('success', 'El tipo de cartera de la cuenta de cobro fue modificada exitosamente.');

        this.chargeAccountId = this.chargeAccountContract.invoiceId;
        this.validateForm(this.chargeAccountContract);
      } catch (error) {
        console.error('Error al actualizar el tipo de cartera de la cuenta de cobro.', error);
      }
    }
  }

  async setClient(clientId: number | null) {
    this.filterCostCenterByClientId(clientId);
    if (clientId != null && clientId != 0) {
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      this.clientId = clientId;
      this.codeCurrency = client.codeCurrency;
      this.stateClientId = client.clientStateId as number | null;
      this.expirationDays = client.expirationDays;

      const exist = this.listClients.some(c => c.value === this.clientId);
      if (!exist) {
        this.listClients.push({ label: client.label, value: this.clientId });
      }

      this.formChargeAccountFirst.controls["clientId"].patchValue(this.clientId);
    }
  }

  async setCostCenter(costCenterId: number | null) {
    if (costCenterId != null && costCenterId != 0) {
      const costCenterModel = await firstValueFrom(this.costCenterService.getCostCenterById(costCenterId));
      this.stateCostCenterId = costCenterModel.constructionSite.constructionSiteStateId;

      const exist = this.listCostCenters.some(c => c.value == costCenterId);
      if (!exist && costCenterModel) {
        this.listCostCenters.push({ clientId: costCenterModel.clientId, label: `${costCenterModel.code} - ${costCenterModel.name}`, value: costCenterId });
      }
      this.formChargeAccountFirst.controls["costCenterId"].patchValue(costCenterId);
      this.filterCostCenterByClientId(costCenterModel.clientId);
    }
  }

  async setTypeDIAN(typeIva: number): Promise<any> {
    let codeTypeDian: number = 0;
    typeIva == IvaTypeEnums.sobreUtilidad ? codeTypeDian = TypeDianEnums.aiu : codeTypeDian = TypeDianEnums.estandar;
    //Busco datos del tipo Dian
    return this.listTypeDIANs.find(x => x.code == codeTypeDian)?.value;
  }

  async updateFormState() {
    switch (this.chargeAccountContract.invoiceStateId) {
      case InvoiceEnums.abierta: {
        this.severityState = 'danger',
          this.iconStateChargeAccount = 'pi pi-lock-open',
          this.titleStateChargeAccount = 'Cerrar';
        this.chargeAccountStateString = "Abierta";
        break;
      }
      case InvoiceEnums.cerrada: {
        this.severityState = 'success',
          this.iconStateChargeAccount = 'pi pi-lock',
          this.titleStateChargeAccount = 'Abrir';
        this.chargeAccountStateString = "Cerrada";
        break;
      }
      case InvoiceEnums.impresa: {
        this.severityState = 'info',
          this.iconStateChargeAccount = 'pi pi-lock',
          this.titleStateChargeAccount = 'Abrir';
        this.chargeAccountStateString = "Impresa";
        break;
      }
      case InvoiceEnums.pagada: {
        this.severityState = 'success',
          this.iconStateChargeAccount = 'pi pi-lock',
          this.titleStateChargeAccount = 'Abrir';
        this.chargeAccountStateString = "Pagada";
        break;
      }
      case InvoiceEnums.anulada: {
        this.severityState = 'warn',
          this.iconStateChargeAccount = 'pi pi-eye',
          this.titleStateChargeAccount = 'Ver';
        this.chargeAccountStateString = "Anulada";
        break;
      }
    }
    if (this.chargeAccountContract.invoiceStateId == InvoiceEnums.abierta && !this.chargeAccountContract.swBlock) {
      this.disabledForm = false;
      setTimeout(() => this.formChargeAccountFirst.enable(), 100);
      if (this.chargeAccountId != 0) {
        setTimeout(() => this.formChargeAccountFirst.controls["consecutive"].enable(), 100);
        setTimeout(() => this.formChargeAccountFirst.controls["branchId"].enable(), 100);
        setTimeout(() => this.formChargeAccountFirst.controls["enterpriseId"].enable(), 100);
        setTimeout(() => this.formChargeAccountFirst.controls["bussinessDocumentsTypeId"].enable(), 100);
      } else {
        setTimeout(() => this.formChargeAccountFirst.controls["consecutive"].disable(), 100);
      }
    } else {
      this.disabledForm = true;
      setTimeout(() => this.formChargeAccountFirst.disable(), 100);
      setTimeout(() => this.formChargeAccountFirst.controls["consecutive"].enable(), 100);
      setTimeout(() => this.formChargeAccountFirst.controls["branchId"].enable(), 100);
      setTimeout(() => this.formChargeAccountFirst.controls["enterpriseId"].enable(), 100);
      setTimeout(() => this.formChargeAccountFirst.controls["bussinessDocumentsTypeId"].enable(), 100);
    }
    this.chargeAccountContract.invoiceStateId == InvoiceEnums.anulada ? this.visibleAnnul = true : this.visibleAnnul = false;
    //Activo o desactivo el botón para cambiar el tipo de cartera:
    if (this.chargeAccountContract.invoiceId != 0 && !this.chargeAccountContract.swBlock) {
      const rentalPeriod = await firstValueFrom(this.invoiceService.getRentalPeriodByIdForRegisterInvoiceAsync(this.chargeAccountContract.rentalPeriodId));
      if ((!rentalPeriod?.active && this.chargeAccountContract.invoiceStateId != InvoiceEnums.pagada) ||
        !this.chargeAccountContract.swManual) {
        this.enableSetChargeAccountWalletType = true;
      } else {
        this.enableSetChargeAccountWalletType = false;
      }
    } else {
      this.enableSetChargeAccountWalletType = false;
    }
    //Inactivo el footer del formulario y los switch de copiada
    setTimeout(() => this.formChargeAccountFooter.disable(), 100);

    if (!this.permissionUpdatable) setTimeout(() => this.formChargeAccountFirst.disable(), 100);
    setTimeout(() => this.formChargeAccountFirst.controls["swManual"].disable(), 100);
    setTimeout(() => this.formChargeAccountFirst.controls["swCopied"].disable(), 100);
    setTimeout(() => this.formChargeAccountFirst.controls["swBlock"].enable(), 100);
  }

  updateInputsForAttachFiles() {
    this.inputsForAttachFiles$.next({
      listFiles: this.listFiles,
      labelConsecutive: this.chargeAccountContract.consecutive,
      disabled: this.chargeAccountContract.invoiceStateId != InvoiceEnums.abierta
    });
  }

  async uploadFile(formData: any) {
    try {
      await firstValueFrom(this.chargeAccountService.attachFilesToChargeAccount(this.chargeAccountId, formData));
      await this.getFilesToChargeAccount();
      this.toastHandlerService.showToast('success', 'Se adjunto el archivo exitosamente', '');
    } catch (error) {
      console.error('Error catch:', error);
    }
  }

  validateDateExpiration() {
    const dateChargeAccount = new Date(this.formChargeAccountFirst.get("dateInvoice")?.value);
    const dateExpiration = new Date(this.formChargeAccountFirst.get("dateExpiration")?.value);
    if (dateExpiration < dateChargeAccount) {
      this.toastHandlerService.showToast(
        'warning',
        'La fecha de vencimiento debe ser MAYOR o IGUAL a la fecha de la cuenta de cobro.'
      );
      this.formChargeAccountFirst.controls["dateExpiration"].patchValue(null);
    }
  }

  async validatePeriodDate() {
    if (this.chargeAccountContract.invoiceId != 0 && this.chargeAccountContract.invoiceId != -1) {
      const periodChargeAccountOldId = this.chargeAccountContract.rentalPeriodId;
      const dateChargeAccount = new Date(this.formChargeAccountFirst.get("dateInvoice")?.value);
      const year = dateChargeAccount.getFullYear() as unknown;
      //Se suma 1 porque la función cuenta los meses desde la posición 0
      const month = dateChargeAccount.getMonth() + 1 as unknown;
      if (periodChargeAccountOldId) {
        const rentalPeriod = await firstValueFrom(this.invoiceService.getRentalPeriodByIdForRegisterInvoiceAsync(periodChargeAccountOldId));
        if (rentalPeriod) {
          if (!rentalPeriod.active) {
            this.toastHandlerService.showToast(
              'warning',
              'La fecha ingresada pertenece a un Período de alquiler Cerrado.'
            );
            this.disabledForm = true;
            return;
          }
          if (this.quantityDetails != 0) {
            if (year != rentalPeriod.codeItem || month != rentalPeriod.nameItem) {
              this.toastHandlerService.showToast(
                'warning',
                'No se puede cambiar la fecha a un Período de alquiler diferente, mientras la cuenta de cobro tenga detalle.'
              );
              this.disabledForm = true;
              return;
            }
          }
        } else {
          //Si no encontró el periodo en la lista es por que no existe
          this.toastHandlerService.showToast(
            'warning',
            'La fecha ingresada no existe en Período de alquiler.'
          );
          this.disabledForm = true;
          return;
        }
      }
    }
    //Asignar fecha de vencimiento
    this.addDaysToDate(this.expirationDays);
    this.validateDateExpiration()
  }

  async validateForm(chargeAccount: InvoiceModel) {
    this.formChargeAccountFirst = this.formBuilder.group({
      branchId: [chargeAccount.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [chargeAccount.enterpriseId, [Validators.required, Validators.min(1)]],
      bussinessDocumentsTypeId: [chargeAccount.bussinessDocumentsTypeId, [Validators.required, Validators.min(1)]],
      bussinessDocumentsTypeIsRental: [chargeAccount.bussinessDocumentsTypeIsRental, []],
      consecutive: [chargeAccount.consecutive, [Validators.required]],
      conceptTypeDIANId: [chargeAccount.conceptTypeDIANId, [Validators.required]],
      dateInvoice: [chargeAccount.dateInvoice ? this.dateConverterService.convertDatePreserveDay(chargeAccount.dateInvoice) : null, [Validators.required]],
      dateExpiration: [chargeAccount.dateExpiration ? this.dateConverterService.convertDatePreserveDay(chargeAccount.dateExpiration) : null, [Validators.required]],
      clientId: [chargeAccount.clientId, [Validators.required, Validators.min(1)]],
      costCenterId: [chargeAccount.costCenterId, []],
      observation: [chargeAccount.observation, [Validators.maxLength(250)]],
      chargeAccountStateId: [chargeAccount.invoiceStateId, []],
      swBlock: [chargeAccount.swBlock, []],
      swManual: [chargeAccount.swManual, []],
      swCopied: [chargeAccount.swCopied, []],
      zoneId: [chargeAccount.zoneId, [Validators.required, Validators.min(1)]],
      sellerId: [chargeAccount.sellerId, [Validators.required, Validators.min(1)]],
      chargeAccountOperationId: [chargeAccount.invoiceOperationId, [Validators.required, Validators.min(1)]],
      chargeAccountWalletTypeId: [chargeAccount.invoiceWalletTypeId, [Validators.required, Validators.min(1)]]
    });

    this.formChargeAccountFooter = this.formBuilder.group({
      paymentValue: [chargeAccount.paymentValue, [Validators.min(0), Validators.max(99999999999.99)]],
      residueValue: [chargeAccount.residueValue, [Validators.min(0), Validators.max(99999999999.99)]],
      subtotalValue: [chargeAccount.subtotalValue, [Validators.min(0), Validators.max(99999999999.99)]],
      discountValue: [chargeAccount.discountValue, [Validators.min(0), Validators.max(99999999999.99)]],
      totalValue: [chargeAccount.totalValue, [Validators.min(0), Validators.max(99999999999.99)]],
      valueToPay: [chargeAccount.valueToPay, [Validators.min(0), Validators.max(99999999999.99)]]
    });
    if (chargeAccount.invoiceId != 0) {
      this.getBussinessDocumentsType(chargeAccount.bussinessDocumentsTypeId, false);
      await this.setClient(chargeAccount.clientId);
      this.getCostCenter(chargeAccount.costCenterId, false);
      this.getZone(chargeAccount.zoneId);
      this.getInvoicingCutoffCode(chargeAccount.invoicingCutoffId);
      this.invoiceOriginConsecutive = chargeAccount.invoiceOriginConsecutive;
      this.getPrintChargeAccounts();
      this.getDetailsChargeAccountWithPagination();
    }
    this.getMovementCode(chargeAccount.movementId);
    this.setTypeDIAN(chargeAccount.ivaTypeId);
    this.updateFormState();
    setTimeout(() => this.formChargeAccountFirst.controls["swBlock"].enable(), 100);
    setTimeout(() => this.formChargeAccountFirst.controls["swCopied"].disable(), 100);
    setTimeout(() => this.formChargeAccountFirst.controls["swManual"].disable(), 100);

  }

  validateFormControls() {
    Object.keys(this.formChargeAccountFirst.controls).forEach((key) => {
      const control = this.formChargeAccountFirst.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }

  visiblePreview(visible: boolean) {
    this.visibleLoading = !visible;
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      // Verifica si el componente de impresión ha terminado de cargar (por ejemplo, si hay una variable que indique que se ha cargado completamente)
      if (this.finishLoadingPrint) {
        //Imprimimos el documento
        print();
        resolve();
      } else {
        // Si no ha terminado de cargar, espera un breve tiempo y vuelve a verificar
        setTimeout(() => this.waitForComponenteImpresionToLoad().then(resolve), 100);
      }
    });
  }
}
